/** CURRENTLY SUPPORTS THE FOLLOWING
 * all - all devices
 * visionOS - only the AVP
 * webXR - all devices except for the AVP
 */
export const checkDeviceEnabled = (enabledDevices) => {
	let deviceEnabled = false;
	for (let device of enabledDevices) {
		switch (device) {
			case 'all':
				deviceEnabled = true;
				break;
			case 'visionOS':
				// only AVP
				deviceEnabled = isAppleDevice();
				break;
			case 'webXR':
				// all devices except AVP
				deviceEnabled = !isAppleDevice();
				break;
			default:
				break;
		}
		if (deviceEnabled) break;
	}
	return deviceEnabled;
};

export const isAppleDevice = () => {
	const platform = navigator?.userAgentData?.platform || navigator?.platform;
	return platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
